<template>
  <ul class="db list ma0 pa0 f5 fw3" id="sideBar">
    <li v-for="(item, index) in tree.filter(i => i.code !== 'settings')" :key="index">
      <div :style="paddingLeft">
        <checkbox class="mt4 mt3-l mh2"
          name="menu_settings"
          :value="item.code"
          :checked="!hidden(item.code)"
          @change="changeVisibility"
          :label="item.title"/>
        <menu-tree v-if="expandable(item.code)" :tree="allChildren(item.code)" :level="level + 1"/>
      </div>
    </li>
  </ul>
</template>

<script>
import MenuTree from '@/components/settings/MenuTree.vue'
import Checkbox from '@/components/ui/Checkbox.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'menu-tree',
  props: {
    tree: {
      type: Array,
      required: true
    },
    level: {
      type: Number,
      default: () => 0
    }
  },
  components: {
    MenuTree,
    Checkbox
  },
  computed: {
    ...mapGetters('settings/menu', ['hidden', 'allChildren', 'expandable']),
    paddingLeft () {
      return 'padding-left: ' + this.level * 25 + 'px;'
    }
  },
  methods: {
    ...mapActions('settings/menu', ['hideItem', 'showItem']),
    changeVisibility (item) {
      item.checked ? this.showItem(item.value) : this.hideItem(item.value)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
